export default __webpack_public_path__ + "static/media/mc_rae_chat.9fbf566e.mp4";